
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("widget/download-link",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p><a class=\"button\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"deepLoginLink") : depth0), depth0))
    + "\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"fw3.download.firebase",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":48},"end":{"line":1,"column":82}}})) != null ? stack1 : "")
    + "</a></p><p class=\"small webonly\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"fw3.download.or",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":115},"end":{"line":1,"column":143}}})) != null ? stack1 : "")
    + "</p><p><a class=\"button webonly\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"URL") : depth0)) != null ? lookupProperty(stack1,"ENTER_HOME") : stack1), depth0))
    + "\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"fw3.download.weblink",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":202},"end":{"line":1,"column":235}}})) != null ? stack1 : "")
    + "</a></p> ";
},"useData":true});
export default TPL;